var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconNeedHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.457 7.29232H13.5404V9.37565H11.457V7.29232ZM11.457 11.459H13.5404V17.709H11.457V11.459ZM12.4987 2.08398C6.7487 2.08398 2.08203 6.75065 2.08203 12.5006C2.08203 18.2506 6.7487 22.9173 12.4987 22.9173C18.2487 22.9173 22.9154 18.2506 22.9154 12.5006C22.9154 6.75065 18.2487 2.08398 12.4987 2.08398ZM12.4987 20.834C7.90495 20.834 4.16536 17.0944 4.16536 12.5006C4.16536 7.9069 7.90495 4.16732 12.4987 4.16732C17.0924 4.16732 20.832 7.9069 20.832 12.5006C20.832 17.0944 17.0924 20.834 12.4987 20.834Z",
    fill: "#337D98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconNeedHelp);
export default __webpack_public_path__ + "static/media/THIcon-NeedHelp.02f92f66edcafbdd98398e9362941b96.svg";
export { ForwardRef as ReactComponent };